export default {
  translation: {
    common: {
      emailOrUsername: 'E-pošta ili korisničko ime',
      invalidEmailOrUsername: 'Neispravna e-pošta ili korisničko ime',
      invalidCredentials: 'Neispravni akreditivi',
      invalidPassword: 'Neispravna lozinka',
      noInternetConnection: 'Nema konekcije sa internetom',
      pageNotFound_title: 'Stranica nije pronađena',
      password: 'Lozinka',
      projectManagement: 'Upravljanje projektima',
      serverConnectionFailed: 'Neuspešna konekcija sa serverom',
      unknownError: 'Nepoznata greška, pokušajte ponovo kasnije',
      useSingleSignOn: 'Koristi univerzalnu prijavu',
    },

    action: {
      logIn: 'Prijava',
      logInWithSSO: 'Prijava sa UP',
    },
  },
};
